import { CommonStyles } from '../../../common/react/CommonStyles';

export const expandoStyle: React.CSSProperties = {
    marginLeft: CommonStyles.Sizes.DefaultSpace,
    marginTop: CommonStyles.Sizes.SmallSpace
};
